import React, { Component } from 'react';
import { connect } from 'react-redux';

class SponsorPane extends Component {
  render() {
    return (
      <div className="t-container-sidebar-pane t-container-sidebar-pane-bottom">
        <div className="t-container-sidebar-content">
          <h3>スポンサー広告</h3>

          <div className="fallback">
            現在スポンサー広告はありません
          </div>
        </div>
      </div>
    );
  }
}

SponsorPane = connect(f => f, {})(SponsorPane);

export default SponsorPane;


// WEBPACK FOOTER //
// ./src/components/Sidebar/SponsorPane.js